import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PIS, { API_URL } from "../../api/api";
import { AppMisc } from "../../misc/appMisc";
import { ERROR, SOMETHING_WENT_WRONG, SUCCESS } from "../../utils/constants";
import AddAlertMessage from "../../components/alert/Alert";

export const getPostInfo = createAsyncThunk('postInfo/getPostInfo', async () => {
  try {
    const response = await PIS.get(API_URL.post);
    const jsondata = response.data;
    if (jsondata.type === SUCCESS) {
      return AppMisc.buildPostOptions(jsondata.data || []);
    } else {
      AddAlertMessage({ type: jsondata.type, message: jsondata.message });

    }
  } catch (error) {
    AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
  }
}
);

export const postInfoSlice = createSlice({
  name: "postInfo",
  initialState: null,
  reducers: {
    reset: () => null,
  },
  extraReducers: (builder) => {
    builder.addCase(getPostInfo.fulfilled, (state, action) => {
      return action.payload;
    });
  },
})
export const { reset } = postInfoSlice.actions
export default postInfoSlice.reducer